import { map } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
import { createBranch, convertUnixToDate, Branch } from '@golden/gdk-base';
export function createAdminService(api, trunk) {
    return {
        me: createBranch({
            trunk,
            branch: Branch.ME,
            value: null,
            operator: () => api.fetch(ADMIN_API.GET_ME)
        }),
        setPerPage: (data) => {
            return api.fetch(ADMIN_API.POST_PER_PAGE, { data });
        },
        changePassword(data) {
            return api.fetch(ADMIN_API.PUT_ADMIN_PASSWORD, { data });
        },
        getAccountList: (data) => {
            return api.fetch(ADMIN_API.GET_ADMIN_LIST, { data })
                .pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'last_login_at'))
            })));
        },
        createAccount: (data) => {
            return api.fetch(ADMIN_API.POST_ADMIN, { data });
        },
        getAccount: (id) => {
            return api.fetch(ADMIN_API.GET_ADMIN, { config: { urlParams: { id } } });
        },
        updateAccount: (id, data) => {
            return api.fetch(ADMIN_API.PUT_ADMIN, { config: { urlParams: { id } }, data });
        },
        deleteAccount: (id) => {
            return api.fetch(ADMIN_API.DELETE_ADMIN, { config: { urlParams: { id } } });
        },
        validateAccount: (account) => {
            return api.fetch(ADMIN_API.GET_VALIDATE_ADMIN_ACCOUNT, { data: { account } });
        },
        validateNickname: (nickname) => {
            return api.fetch(ADMIN_API.GET_VALIDATE_ADMIN_NICKNANE, { data: { nickname } });
        }
    };
}
//# sourceMappingURL=AdminService.js.map